import { useCallback } from "react";
import { useRecoilValue } from "recoil";

import {
  DEFAULT_ROUTE_COLOR_OBJECT,
  resolveAlternateColor,
  routeColorIdMatchesResolvedSelector,
  routeColorsByIdMapping,
} from "@ryde/shared";

export const useMapColors = () => {
  const rideColorMatches = useRecoilValue(routeColorIdMatchesResolvedSelector);
  const getRouteColorIdByRideId = useCallback(
    (rideId: number, isTrackingRouteColor = false): number => {
      if (rideColorMatches.has(rideId)) {
        const matchedColorId =
          rideColorMatches.get(rideId) || DEFAULT_ROUTE_COLOR_OBJECT.colorId;
        return resolveAlternateColor(matchedColorId, isTrackingRouteColor);
      } else {
        return resolveAlternateColor(
          DEFAULT_ROUTE_COLOR_OBJECT.colorId,
          isTrackingRouteColor,
        );
      }
    },
    [rideColorMatches],
  );

  const getMapColorByRideId = useCallback(
    (rideId: number, alt = false): string => {
      return routeColorsByIdMapping[getRouteColorIdByRideId(rideId, alt)];
    },
    [getRouteColorIdByRideId],
  );

  return {
    getMapColorByRideId,
    getRouteColorIdByRideId,
  };
};
